module.exports = __webpack_public_path__ + "static/media/mailen-allegretti.add4ac32.jpg";